import { AppLink } from '../constants';

export const openAppLink = () => {
  window.open(AppLink, '_blank');
};
